"use strict";

import React from "react";

class RoleDescription extends React.Component {
  render() {
    switch (this.props.role) {
      case "projectManager":
        return <span>I'm a Project Manager</span>;
      case "departmentManager":
        return <span>I'm a Department Manager</span>;
      case "portfolioManager":
        return <span>I'm a Portfolio Manager</span>;
      case "programManager":
        return <span>I'm a Program Manager</span>;
      case "ceo":
        return <span>I'm a CEO</span>;
      case "dagligTjener":
        return <span>I'm Kate</span>;
      default:
        return <span>I'm {this.props.role}</span>;
    }
  }
}

export default class Demo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  startTour(event) {
    event.preventDefault();
    this.setState({ start: !this.state.start });
  }

  render() {
    return (
      <div
        style={{
          position: "relative",
          border: "solid 3px red",
          color: "red",
          textAlign: "center",
          margin: 5,
          padding: 5,
        }}
      >
        <span style={{ float: "left" }}>DEMO!</span>
        {this.props.environment === undefined ||
        this.props.environment.demo === undefined ? (
          <a href="#" onClick={this.startTour.bind(this)}>
            Start your tour
          </a>
        ) : (
          <span>
            <RoleDescription role={this.props.environment.demo.role} />
          </span>
        )}
        <span style={{ float: "right" }}>DEMO!</span>
        {this.state.start ? (
          <div
            style={{
              position: "absolute",
              textAlign: "left",
              color: "black",
              padding: 15,
              zIndex: 1,
              backgroundColor: "white",
              boxShadow: "0px 8px 16px 0px rgba(0,0,0,0.2)",
              border: "solid black 1px",
            }}
          >
            <b>Tour menu</b>
            <ul>
              <li style={{ paddingBottom: 10 }}>
                <a href="http://progreto.eu">Documentation</a>
              </li>
              <li style={{ paddingBottom: 10 }}>
                <a href="/demo/alex.moore@demo.progreto.com">
                  I am Alex Moore, project manager at <br />
                  Independent Vibes Records
                  <br />
                  (Axelos Sample Exam)
                </a>
              </li>
              <li>
                <a href="/demo/projectManager">I am a project manager</a>
              </li>
              <li>
                <a href="/demo/departmentManager">I am a department manager</a>
              </li>
              <li>
                <a href="/demo/portfolioManager">I am a portfolio manager</a>
              </li>
              <li>
                <a href="/demo/programManager">I am a program manager</a>
              </li>
              <li>
                <a href="/demo/ceo">I am a CEO</a>
              </li>
              <li>
                <a href="/demo/dagligTjener">
                  I am a "<i>daglig tjener</i>"
                </a>
              </li>
            </ul>
          </div>
        ) : null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./views/demo/Demo.jsx